export default "__VITE_ASSET__DF34c4jJ__"